import { getSupabase } from "../components/supabaseClient";
import { requestAttachmentUploads } from "../services/messagingService";

// Chat attachments: validated here, uploaded straight to the private
// internal-messaging bucket with one-time links from the backend (file bytes
// never pass through the Django/Daphne process).
export const ATTACHMENTS_BUCKET = "internal-messaging";
export const MAX_FILES = 10;
export const MAX_FILE_BYTES = 25 * 1024 * 1024;
const MAX_FILE_MB = Math.floor(MAX_FILE_BYTES / (1024 * 1024));

export function formatBytes(n) {
  const size = Number(n) || 0;
  if (size < 1024) return `${size} B`;
  if (size < 1024 * 1024) return `${Math.round(size / 1024)} KB`;
  return `${(size / (1024 * 1024)).toFixed(1)} MB`;
}

export function isImageType(type) {
  return /^image\//i.test(String(type || ""));
}

// current: files already queued; incoming: files just picked, dropped or pasted.
export function validateNewFiles(current, incoming) {
  const accepted = [];
  const rejected = [];
  let room = MAX_FILES - (current ? current.length : 0);
  for (const f of incoming || []) {
    if (!f) continue;
    if (!f.size) rejected.push({ name: f.name, reason: "is empty" });
    else if (f.size > MAX_FILE_BYTES) rejected.push({ name: f.name, reason: `is larger than ${MAX_FILE_MB} MB` });
    else if (room <= 0) rejected.push({ name: f.name, reason: `would exceed ${MAX_FILES} files` });
    else {
      accepted.push(f);
      room -= 1;
    }
  }
  return { accepted, rejected };
}

// Upload one message's files; returns the list messages/send/ expects.
// Throws (naming the file) if any upload fails — the caller then sends nothing.
export async function uploadChatFiles(channelId, senderId, files) {
  if (!files || files.length === 0) return [];
  const { uploads } = await requestAttachmentUploads(
    channelId,
    senderId,
    files.map((f) => ({ name: f.name, size: f.size, type: f.type || "application/octet-stream" })),
  );
  const supabase = await getSupabase();
  const bucket = supabase.storage.from(ATTACHMENTS_BUCKET);
  await Promise.all(
    uploads.map(async (u, i) => {
      const { error } = await bucket.uploadToSignedUrl(u.path, u.token, files[i], { contentType: u.type, upsert: false });
      if (error) throw new Error(`${files[i].name}: ${error.message || "upload failed"}`);
    }),
  );
  return uploads.map(({ path, name, size, type }) => ({ path, name, size, type }));
}
